import { FcGoogle } from 'react-icons/fc';
import { Button } from '@/components/atoms/ui/button';

interface LoginButtonComponentProps {
  isSigningIn: boolean;
  onLogin: () => void;
}

export const LoginButtonComponent: React.FC<LoginButtonComponentProps> = ({
  isSigningIn,
  onLogin,
}) => {
  return (
    <Button
      onClick={onLogin}
      variant="outline"
      size="lg"
      disabled={isSigningIn}
      className="login-button-component border-border hover:bg-accent hover:border-border"
    >
      <FcGoogle className="mr-2 h-5 w-5" />
      {isSigningIn ? 'Signing in...' : 'Sign in with Google'}
    </Button>
  );
};

